<template>
	<div class="pl-2 pb-2">
		<div v-if="showOriginalText" v-html="originalText" class="expression-content ql-editor rounded-lg px-3 py-2"></div>
		<div v-else v-html="formattedText" class="expression-content ql-editor rounded-lg px-3 py-2"></div>
		<div v-if="$vuetify.breakpoint.mdAndUp" class="bt-block">
			<div class="show-hide-original-text">
				<v-icon v-if="showOriginalText" @click="showCorrectionText">mdi-eye-outline</v-icon>
				<v-icon v-else @click="showOriginal">mdi-eye-off-outline</v-icon>
				<div>
					<span
						:class="{ 'font-weight-bold': showOriginalText, 'cursor-pointer': !showOriginalText }"
						@click="showOriginal"
					>
						Originale
					</span>
					|
					<span
						:class="{ 'font-weight-bold': !showOriginalText, 'cursor-pointer': showOriginalText }"
						@click="showCorrectionText"
					>
						Correction
					</span>
				</div>
			</div>
			<div>
				<DownloadExpressionAnswer :formattedText="formattedText" :originalText="originalText" />
			</div>
		</div>
	</div>
</template>

<script>
import DownloadExpressionAnswer from './DownloadExpressionAnswer.vue';

export default {
	name: 'ExpressionAnswerDisplay',
	components: {
		DownloadExpressionAnswer,
	},
	props: { formattedText: String, originalText: String },
	data() {
		return {
			showOriginalText: false,
		};
	},
	methods: {
		showOriginal() {
			this.showOriginalText = true;
		},
		showCorrectionText() {
			this.showOriginalText = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.expression-content {
	width: 100%;
	min-height: 300px;
	outline: none;
	resize: none;
	white-space: pre-wrap;
	text-align: left;

	&:disabled {
		cursor: not-allowed;
	}
}

.bt-block {
	display: flex;
	align-items: center;
	justify-content: space-between;

	.show-hide-original-text {
		display: flex;
		align-items: center;
		gap: 8px;
	}
}
</style>
